export const UITR = {
  UI: {
    Dashboard: {
      Shipments: { en: 'Shipments', cs: 'Přepravy', dataType: 'string' },
      AddShipment: { en: 'Add Shipment', cs: 'Přidat přepravu', dataType: 'string' },
      Carriers: { en: 'Carriers', cs: 'Dopravci', dataType: 'string' },
      MyNextReviewDate: { en: 'My Next Review Date', cs: 'Moje další přezkoumání', dataType: 'string' },
      BIReport: { en: 'BI Report', cs: 'BI Report', dataType: 'string' },
      Manual: { en: 'Manual', cs: 'Manual', dataType: 'string' }
    },
    Menu: {
      Home: { en: 'Home', cs: 'Domů', dataType: 'string' },
      Browse: { en: 'Browse', cs: 'Procházet', dataType: 'string' },
      Tools: { en: 'Tools', cs: 'Nástroje', dataType: 'string' },
      Settings: { en: 'Settings', cs: 'Nastavení', dataType: 'string' },
      Users: { en: 'Users', cs: 'Uživatelé', dataType: 'string' },
      Shipments: { en: 'Shipments', cs: 'Přepravy', dataType: 'string' },
      RecurringShipments: { en: 'Recurring Shipments', cs: 'Pravidelné přepravy', dataType: 'string' },
      Carriers: { en: 'Carriers', cs: 'Dopravci', dataType: 'string' },
      Addresses: { en: 'Addresses', cs: 'Adresy', dataType: 'string' },
      AddressesStates: { en: 'Addresses (States)', cs: 'Adresy (Státy)', dataType: 'string' },
      Currencies: { en: 'Currencies', cs: 'Měny', dataType: 'string' },
      Accounts: { en: 'Accounts', cs: 'Účty', dataType: 'string' },
      ApplicationConfig: { en: 'Application Config', cs: 'Konfigurace aplikace', dataType: 'string' },
      NumberGenerator: { en: 'Number Generator', cs: 'Generátor čísel', dataType: 'string' },
      PermissionGroup: { en: 'Permission Group', cs: 'Skupina oprávnění', dataType: 'string' },
      ElementHelp: { en: 'Element Help', cs: 'Nápověda elementů', dataType: 'string' },
      EventLog: { en: 'Event Log', cs: 'Protokol událostí', dataType: 'string' },
      Hangfire: { en: 'Hangfire', cs: 'Hangfire', dataType: 'string' }
    },
    UserPanel: {
      Profile: { en: 'Profile', cs: 'Profil', dataType: 'string' },
      Logout: { en: 'Logout', cs: 'Odhlásit se', dataType: 'string' },
      Settings: { en: 'Settings', cs: 'Nastavení', dataType: 'string' }
    },
    Tab: {
      General: { en: 'General', cs: 'Obecné', dataType: 'string' },
      Carriers: { en: 'Carriers', cs: 'Dopravci', dataType: 'string' },
      Route: { en: 'Route', cs: 'Cesta', dataType: 'string' }
    },
    Button: {
      AddRoute: { en: 'Add Route', cs: 'Přidat cestu', dataType: 'string' },
      DeleteRoute: { en: 'Delete Route', cs: 'Smazat cestu', dataType: 'string' },
      ChangeStatus: { en: 'Change Status', cs: 'Změnit stav', dataType: 'string' },
      Save: { en: 'Save', cs: 'Uložit', dataType: 'string' },
      Cancel: { en: 'Cancel', cs: 'Zrušit', dataType: 'string' },
      Delete: { en: 'Delete', cs: 'Smazat', dataType: 'string' },
      Close: { en: 'Close', cs: 'Zavřít', dataType: 'string' },
      Refresh: { en: 'Refresh', cs: 'Obnovit', dataType: 'string' },
      Export: { en: 'Export', cs: 'Exportovat', dataType: 'string' },
      New: { en: 'New', cs: 'Nový', dataType: 'string' },
      FixErrorsAndFinish: { en: 'Fix errors and finish status change', cs: 'Opravit chyby a dokončit změnu stavu', dataType: 'string' },
      Submit: { en: 'Submit', cs: 'Odeslat', dataType: 'string' }
    },
    Hint: {
      AddRoute: { en: 'Add Route', cs: 'Přidat cestu', dataType: 'string' },
      DeleteRoute: { en: 'Delete Route', cs: 'Smazat cestu', dataType: 'string' }
    },
    Dialog: {
      ConfirmStatusChange: { en: 'Confirm Status Change', cs: 'Potvrdit změnu stavu', dataType: 'string' },
      Confirmation: { en: 'Confirmation', cs: 'Potvrzení', dataType: 'string' },
      Error: { en: 'Error', cs: 'Chyba', dataType: 'string' },
      Warning: { en: 'Warning', cs: 'Varování', dataType: 'string' },
      Information: { en: 'Information', cs: 'Informace', dataType: 'string' },
      SelectStatus: { en: 'Select Status', cs: 'Vyberte stav', dataType: 'string' },
      CancelReason: { en: 'Cancel Reason', cs: 'Důvod zrušení', dataType: 'string' },
      StateCancelReason: { en: 'State your Cancel Reason:', cs: 'Uveďte důvod zrušení:', dataType: 'string' },
      Ok: { en: 'Ok', cs: 'Ok', dataType: 'string' },
      Yes: { en: 'Yes', cs: 'Ano', dataType: 'string' },
      No: { en: 'No', cs: 'Ne', dataType: 'string' },
      Cancel: { en: 'Cancel', cs: 'Zrušit', dataType: 'string' },
      DialogPopup: { en: 'Dialog Popup', cs: 'Dialogové okno', dataType: 'string' }
    },
    Message: {
      ConfirmStatusChange: { en: 'Really change status to {0}?', cs: 'Opravdu změnit stav na {0}?', dataType: 'string' },
      ChangeStatusTo: { en: 'Change status to \'{0}\'', cs: 'Změnit stav na \'{0}\'', dataType: 'string' },
      SaveSuccess: { en: 'Successfully saved', cs: 'Úspěšně uloženo', dataType: 'string' },
      DeleteConfirm: { en: 'Are you sure you want to delete this record?', cs: 'Opravdu chcete smazat tento záznam?', dataType: 'string' },
      DeleteSuccess: { en: 'Successfully deleted', cs: 'Úspěšně smazáno', dataType: 'string' },
      UnsavedChanges: { en: 'You have unsaved changes. Do you want to continue?', cs: 'Máte neuložené změny. Chcete pokračovat?', dataType: 'string' },
      NoRecordsFound: { en: 'No records found', cs: 'Nebyly nalezeny žádné záznamy', dataType: 'string' },
      Loading: { en: 'Loading...', cs: 'Načítání...', dataType: 'string' },
      SubmitSuccess: { en: 'Your offer has been successfully submitted', cs: 'Vaše nabídka byla úspěšně odeslána', dataType: 'string' },
      SubmitSuccessTitle: { en: 'Submission Successful', cs: 'Odeslání úspěšné', dataType: 'string' }
    },
    Caption: {
      RouteNumber: { en: 'Route - {0}', cs: 'Cesta - {0}', dataType: 'string' },
      Notes: { en: 'Notes', cs: 'Poznámky', dataType: 'string' },
      WinnerManual: { en: 'Winner - Manually Selected - {0}', cs: 'Vítěz - ručně vybraný - {0}', dataType: 'string' },
      WinnerTender: { en: 'Tender Winner - {0}', cs: 'Vítěz tendru - {0}', dataType: 'string' },
      CarrierOffer: { en: 'Carrier Offer - {0}', cs: 'Nabídka dopravce - {0}', dataType: 'string' },
      TransportDetails: { en: 'Transport Details', cs: 'Podrobnosti dopravy', dataType: 'string' },
      Tender: { en: 'Tender', cs: 'Tender', dataType: 'string' }
    },
    Common: {
      Yes: { en: 'Yes', cs: 'Ano', dataType: 'string' },
      No: { en: 'No', cs: 'Ne', dataType: 'string' },
      OK: { en: 'OK', cs: 'OK', dataType: 'string' },
      Apply: { en: 'Apply', cs: 'Použít', dataType: 'string' },
      Search: { en: 'Search', cs: 'Hledat', dataType: 'string' },
      Filter: { en: 'Filter', cs: 'Filtr', dataType: 'string' },
      Clear: { en: 'Clear', cs: 'Vymazat', dataType: 'string' },
      SelectAll: { en: 'Select All', cs: 'Vybrat vše', dataType: 'string' },
      DeselectAll: { en: 'Deselect All', cs: 'Zrušit výběr', dataType: 'string' }
    },
    NewSection: {
      NewKey: { en: 'English Text', cs: 'Czech Text', dataType: 'string' }
    },
    Login: {
      Username: { en: 'Username', cs: 'Uživatelské jméno', dataType: 'string' },
      Password: { en: 'Password', cs: 'Heslo', dataType: 'string' },
      UsernameOrEmail: { en: 'Username or Email', cs: 'Uživatelské jméno nebo Email', dataType: 'string' },
      SignIn: { en: 'Sign in', cs: 'Přihlásit se', dataType: 'string' },
      Processing: { en: 'Processing', cs: 'Zpracovávám', dataType: 'string' },
      SendPasswordReset: { en: 'Send Password Reset Email', cs: 'Odeslat email pro reset hesla', dataType: 'string' },
      PasswordReset: { en: 'Password Reset >>', cs: 'Reset hesla >>', dataType: 'string' },
      Back: { en: 'Back >>', cs: 'Zpět >>', dataType: 'string' },
      Loading: { en: 'Loading ....', cs: 'Načítání ....', dataType: 'string' },
      UsernameRequired: { en: 'Username is required', cs: 'Uživatelské jméno je povinné', dataType: 'string' },
      PasswordRequired: { en: 'Password is required', cs: 'Heslo je povinné', dataType: 'string' },
      UsernameNotEntered: { en: 'Username not entered', cs: 'Uživatelské jméno nebylo zadáno', dataType: 'string' },
      PasswordNotEntered: { en: 'Password not entered', cs: 'Heslo nebylo zadáno', dataType: 'string' },
      PasswordResetEmailSent: { en: 'Reset password email sent', cs: 'Email pro reset hesla byl odeslán', dataType: 'string' },
      CannotLoginWithDefaultPassword: { en: 'You cannot log into another user\'s account with default password. Reset password email has been sent to the owner of the account you are currently signing in.', cs: 'Nemůžete se přihlásit k účtu jiného uživatele s výchozím heslem. Email pro reset hesla byl odeslán vlastníkovi účtu, ke kterému se přihlašujete.', dataType: 'string' }
    },
    Toolbar: {
      Save: { en: 'Save', cs: 'Uložit', dataType: 'string' },
      Delete: { en: 'Delete', cs: 'Smazat', dataType: 'string' },
      Log: { en: 'Log', cs: 'Protokol', dataType: 'string' },
      Copy: { en: 'Copy', cs: 'Kopírovat', dataType: 'string' },
      New: { en: 'New', cs: 'Nový', dataType: 'string' },
      Edit: { en: 'Edit', cs: 'Upravit', dataType: 'string' },
      CopyLink: { en: 'Copy Link', cs: 'Kopírovat odkaz', dataType: 'string' }
    }
  }
};